<template>
	<div class="submitWrapper paddBottom">
		<IndexHeaderOthers ref="indexHeader"></IndexHeaderOthers>
		<div class="main">
			<div class="conner">
				<div class="height38" style="height: 38px"></div>
				<div class="tabList">
					<div :class="activeName == 'Subscription' ? 'isActive tab' : 'tab'"
						@click="changeTab('Subscription')">
						<!-- @click="activeName = 'Subscription'" -->
						Subscription
					</div>
					<!-- <div :class="activeName == 'Upload' ? 'isActive tab' : 'tab'" @click="changeTab('Upload')">
						Upload
					</div> -->
				</div>
				<div class="search">
					<div class="content-input-left-footer">
						<div class="content-input-left-footer-top">
							<h1>Trigger Time :</h1>
							<el-date-picker class="p-tw" v-model="value1" type="date" placeholder="From date">
							</el-date-picker>
							<div class="to">to</div>
							<el-date-picker class="p-tw" v-model="value2" type="date" placeholder="End date">
							</el-date-picker>
						</div>
						<div class="content-input-left-footer-bottom">
							<p>Name :</p>
							<el-input v-model="input" placeholder=""></el-input>
						</div>
						<div class="subBtn">
							<button class="content-input-right-top" @click="reset">Reset</button>
							<button class="content-input-right-footer" @click="onSubmit">Search</button>
							<!-- <div class="cancel">Reset</div>
							<div class="submit" @click="onSubmit">Search</div> -->
						</div>
					</div>
				</div>
				<div class="line"></div>
				<div class="cutMain" v-if="activeName == 'Subscription'">
					<div class="leftCheck">
						<div class="one">
							<div class="title">Type</div>
							<div class="checkList">
								<el-checkbox-group v-model="checkList" @change="changeCheck">
									<el-checkbox v-for="(item, index) in ListGroup" :key="index" :label="item">
									</el-checkbox>
								</el-checkbox-group>
							</div>
						</div>
						<div class="sec">
							<div class="title">Wavebands</div>
							<div class="checkList">
								<el-checkbox-group v-model="checkList2" @change="changeCheck2" class="checkListitem">
									<el-checkbox v-for="(item, index) in ListGroup2" :key="index" :label="item.id">
										{{item.name}}
									</el-checkbox>
								</el-checkbox-group>
							</div>
						</div>
					</div>
					<div class="eventstable" v-if="typeName == 'Notices'">

						<el-table v-loading="loading" :data="NoticeList" style="width: 100%" @row-click="clickInfo" :header-cell-style="{
							background: '#F0F3F8',
							height: '42px',
						}">
							<el-table-column v-for="item in NoticeListColumn" :key="item.key" :label="item.name"
								:prop="item.prop" :sortable="item.sort" :width="180">
								<template slot-scope="scope">
									{{(scope.row[item.prop] == '' || scope.row[item.prop] == 0)?'-':scope.row[item.prop]}}
								</template>
							</el-table-column>
						</el-table>
						<div class="CuntPage">
							<CuntPage @handleCurrentChanges="handchange" :totalTwo="total" @handleSizeChange="sizeChange"
								:currentPage="currentPage"></CuntPage>
						</div>
					</div>
					<div class="eventstable" v-if="typeName == 'Circulars'">
						<el-table v-loading="loading" :data="CircularsList" @row-click="clickInfo" :header-cell-style="{ background: '#F0F3F8' }"
							header-row-style="{height:'42px'}">
							<el-table-column v-for="item in cularsListColumn" :key="item.key" :label="item.name"
								:prop="item.prop" :sortable="item.sort" :width="180">
								<template slot-scope="scope">
									{{(scope.row[item.prop] == '' || scope.row[item.prop] == 0)?'-':scope.row[item.prop]}}
								</template>
							</el-table-column>
						</el-table>
						<div class="CuntPage">
							<CuntPage @handleCurrentChanges="handchange" :totalTwo="total" @handleSizeChange="sizeChange"
								:currentPage="currentPage"></CuntPage>
						</div>
					</div>
					<div class="eventstable" v-if="typeName == 'ATel'">
						<el-table v-loading="loading" :data="ATelList" @row-click="clickInfo" :header-cell-style="{ background: '#F0F3F8' }"
											header-row-style="{height:'42px'}">
							<el-table-column v-for="item in ATelListColumn" :key="item.key" :label="item.name"
															 :prop="item.prop" :sortable="item.sort" :width="180">
								<template slot-scope="scope">
									{{(scope.row[item.prop] == '' || scope.row[item.prop] == 0)?'-':scope.row[item.prop]}}
								</template>
							</el-table-column>
						</el-table>
						<div class="CuntPage">
							<CuntPage @handleCurrentChanges="handchange" :totalTwo="total" @handleSizeChange="sizeChange"
												:currentPage="currentPage"></CuntPage>
						</div>
					</div>
					<div class="eventstable eventstableonly" v-if="typeName == 'Customize'">
						<el-table v-loading="loading" :data="CustomizeList" @row-click="clickInfo" style="width: 100%"
							:header-cell-style="{ background: '#F0F3F8' }">
							<el-table-column v-for="item in CustomizeListColumn" :key="item.key" :label="item.name"
								:prop="item.prop" :sortable="item.sort" show-overflow-tooltip :width="180">
								<template slot-scope="scope">
									{{(scope.row[item.prop] == '' || scope.row[item.prop] == 0)?'-':scope.row[item.prop]}}
								</template>
							</el-table-column>
						</el-table>
						<div class="CuntPage">
							<CuntPage @handleCurrentChanges="handchange" :totalTwo="total" @handleSizeChange="sizeChange"
								:currentPage="currentPage"></CuntPage>
							<!-- <CuntPage></CuntPage> -->
						</div>
					</div>
				</div>
				<div class="cunMainer" v-if="activeName == 'Upload'" style="margin-top: 32px">
					<div class="eventstable2">
						<el-table v-loading="loading" @row-click="clickInfo" :data="CustomizeList2" style="width: 100%"
							:header-cell-style="{ background: '#F0F3F8' }">
							<el-table-column v-for="item in CustomizeListColumn" :key="item.key" :label="item.name"
								:prop="item.prop" :sortable="item.sort" show-overflow-tooltip :render-header="headerFn" :width="180">
								<template slot-scope="scope">
									{{(scope.row[item.prop] == '' || scope.row[item.prop] == 0)?'-':scope.row[item.prop]}}
								</template>
							</el-table-column>
						</el-table>
						<div class="CuntPage">
							<CuntPage @handleCurrentChanges="handchange" :totalTwo="total" @handleSizeChange="sizeChange"
								:currentPage="currentPage"></CuntPage>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import IndexHeaderOthers from "../components/header/indexHeaderOthers.vue";
import CuntPage from "../components/page/CuntPage";
import { format } from "@/utils/index.js"

export default {
	name: "PersonalCenter",
	components: { IndexHeaderOthers, CuntPage },
	data() {
		return {
			activeName: "Subscription",
			value1: "",
			value2: "",
			input: "",
			total: 0,
			currentPage: 1,
			pageNo: 1,
			pageSize: 10,
			loading: true,
			NoticeList: [],
			NoticeListColumn: [{
					prop: "noticeType",
					name: "Notice Type",
				},
				{
					prop: "eventName",
					name: "Events",
				},
				{
					prop: "triggerTime",
					name: "Trigger Time (UTC)",
					sort: true,
				},
				{
					prop: "telescope",
					name: "Telescope",
					sort: true,
				},
				{
					prop: "objectClass",
					name: "Class",
				},
				{
					prop: "ra",
					name: "RA",
				},
				{
					prop: "declination",
					name: "DEC",
				},
				{
					prop: "positioningError",
					name: "Loc_err (deg)",
				},
				{
					prop: "noticeDate",
					name: "Notice Time",
				},
			],
			CircularsList: [],
			cularsListColumn: [
				{
					prop: "number",
					name: "Circular Number",
				},
				{
					prop: "subject",
					name: "Subject",
				},
				{
					prop: "eventName",
					name: "Events",
					sort: true,
				},
				{
					prop: "triggerTime",
					name: "Burst Time (UTC)",
					sort: true,
				},
				{
					prop: "telescope",
					name: "Telescope",
				},
				{
					prop: "objectClass",
					name: "Class",
				},
				{
					prop: "ra",
					name: "RA",
				},
				{
					prop: "declination",
					name: "DEC",
				},
				{
					prop: "positioningError",
					name: "Loc_err (deg)",
				},
				{
					prop: "circularTime",
					name: "Circular time",
				},
			],
			ATelList: [],
			ATelListColumn: [
				{
					prop: "number",
					name: "ATel Number",
				},
				{
					prop: "title",
					name: "title",
				},
				{
					prop: "eventName",
					name: "Events",
					sort: true,
				},
				{
					prop: "triggerTime",
					name: "Burst Time (UTC)",
					sort: true,
				},
				{
					prop: "telescope",
					name: "Telescope",
				},
				{
					prop: "objectClass",
					name: "Class",
				},
				{
					prop: "ra",
					name: "RA",
				},
				{
					prop: "declination",
					name: "DEC",
				},
				{
					prop: "positioningError",
					name: "Loc_err (deg)",
				},
				{
					prop: "atelTime",
					name: "ATel time",
				},
			],
			CustomizeList: [],
			CustomizeList2: [],
			CustomizeListColumn: [
				// {
				// 	prop: "number",
				// 	name: "Circular Number",
				// },
				// {
				// 	prop: "title",
				// 	name: "Circular Title",
				// },
				{
					prop: "title",
					name: "Title",
				},
				{
					prop: "eventName",
					name: "Events",
				},
				{
					prop: "triggerTime",
					name: "Burst Time (UTC)",
				},
				{
					prop: "telescope",
					name: "Telescope",
				},
				{
					prop: "objectClass",
					name: "Class",
				},
				{
					prop: "ra",
					name: "RA",
				},
				{
					prop: "declination",
					name: "DEC",
				},
				{
					prop: "positioningError",
					name: "Loc_err (deg)",
				},
				{
					prop: "createDate",
					name: "Time",
				}
				
				
				// {
				// 	prop: "eventName",
				// 	name: "Events",
				// },
				// {
				// 	prop: "triggerTime",
				// 	name: "Burst Time (UTC)",
				// },
				// {
				// 	prop: "telescope",
				// 	name: "Telescope",
				// },
				// {
				// 	prop: "objectClass",
				// 	name: "Class",
				// },
				// {
				// 	prop: "ra",
				// 	name: "RA",
				// },
				// {
				// 	prop: "declination",
				// 	name: "DEC",
				// },
				// {
				// 	prop: "positioningError",
				// 	name: "Loc_err (deg)",
				// },
				// {
				// 	prop: "createDate",
				// 	name: "Time",
				// }
			],
			checkList: ["Notices"],
			checkList2: [],
			// ListGroup: ["Notices", "Circulars", "Customize"],
			ListGroup: ["Notices", "Circulars","ATel"],
			typeName: '',
			ListGroup2: [
				"VHE",
				"GW",
				"Neutrino",
				"X-ray",
				"Gamma",
				"Radio",
				"Optical",
			],

		};
	},
	mounted() {
		this.getData(this.checkList[0]);
		this.getWavebands()
		// window.addEventListener("scroll", this.$refs.indexHeader.scrollToTop, true);
	},
	watch: {
		activeName(newName, oldName) {
			// console.log(newName, oldName)
			// this.activeName = newName; //监听属性
			// this.getData("upload");
		},
		//第二种写法，推荐这种写法，因为需要用到监听自身的一些属性时候，只能用这种写法
		// firstName: {
		//   handler(newName, oldName) {
		//     this.fullName = newName;
		//   },
		// },
	},
	methods: {
		getWavebands() {
		  this.$fetchGet("/cms-middle/astronTag/all?type=telescope")
		    .then((res) => {
		        this.ListGroup2 = res.data.telescope
		    })
		    .catch((err) => {});
		},
		reset(){
				this.pageNo = 1,
				this.pageSize = 10,
				this.value1 = '',
				this.value2 = '',
				this.input = '',
				this.checkList = ["Notices"],
				this.checkList2 = []
				this.getData(this.typeName)
		},
		changeTab(name){
			this.activeName = name
			console.log(this.checkList)
			this.typeName = this.checkList[0]
			console.log(this.activeName)
			if(this.activeName == 'Upload'){
				this.getData("Upload");
			}else{
				this.getData(this.typeName)
			}
			console.log(this.typeName)
		},
		clickInfo(row, column, event) {
			if (this.currentRowId === row.id) return
			this.currentRowId = row.id
			console.log(row, column, event);
			console.log(this.id, row.id, "aaa");
			localStorage.setItem('personCenter','personCenter')
			if (this.typeName == "Notices") {
				if (this.id !== row.id) {
					this.id = row.id;
					let a = {
						activeName:'Notice',
						id:this.id,
						eventId:row.eventId
					}
					console.log(a)
					// this.$router.push({
					// 	path: "/Notice",
					// 	query: {
					// 		id: row.id,
					// 		eventId:row.eventId
					// 	},
					// });
					let routedata = this.$router.resolve({
						path: "/Notice",
						query: {
							id: row.id,
							eventId:row.eventId
						},
					});
					window.open(routedata.href, '_blank');
					this.$emit('getInfo',a)
					this.id = row.id;
				} else {
					return {};
				}
			} else if (this.typeName == "Circulars") {
				if (this.id !== row.id) {
					this.id = row.id;
					let a = {
						activeName:'Circulars',
						id:this.id
					}
					// this.$router.push({
					// 	path: "/Circulars",
					// 	query: {
					// 		id: row.id,
					// 		eventId:row.eventId
					// 	},
					// });
					let routedata = this.$router.resolve({
						path: "/Circulars",
						query: {
							id: row.id,
							eventId:row.eventId
						},
					});
					window.open(routedata.href, '_blank');
					this.$emit('getInfo',a)
					this.id = row.id;
				} else {
					return {};
				}
			} else if (this.typeName == "Customize") {
				if (this.id !== row.id) {
					this.id = row.id;
					// this.$router.push({
					// 	path: "/Customize",
					// 	query: {
					// 		id: row.id,
					// 		eventId:row.eventId
					// 	},
					// });
					let routedata = this.$router.resolve({
						path: "/Customize",
						query: {
							id: row.id,
							eventId:row.eventId
						},
					});
					window.open(routedata.href, '_blank');
					this.id = row.id;
				} else {
					return {};
				}
			}
		},
		getData(type) {
			console.log(this.checkList2)
			if(this.checkList2.length != 0){
				var tagIds = this.checkList2.join(',')
			}else{
				var tagIds = ''
			}
			console.log(type)
			this.typeName = type;
			let url = "";
			if (type == "Notices") {
				url = "/cms-middle/astronNotice/subscribe";
			} else if (type == "Circulars") {
				url = "/cms-middle/astronCircular/subscribe";
			} else if (type == "ATel") {
				url = "/cms-middle/astronAtel/subscribe";
			} else if (type == "Customize") {
				url = "/cms-middle/astronCustomize/subscribe";
			} else if (type == "Upload") {
				url = "/cms-middle/astronCustomize/my";
			}
			console.log(url)
			if(this.value1){
				this.value1 = this.format(this.value1,'yyyy-MM-dd hh:mm:ss')
			}
			if(this.value2){
				this.value2 = this.format(this.value2,'yyyy-MM-dd hh:mm:ss')
			}
			var parma = {
				pageNo:this.pageNo,
				pageSize:this.pageSize,
				beginTriggerTime: this.value1,
				endTriggerTime:this.value2,
				title:this.input,
				tagIds:tagIds,
        telescope:tagIds
			}
			if(url == "/cms-middle/astronCustomize/my"){
				this.$fetchPost(url, parma)
					.then((res) => {
						console.log(res);
						this.CustomizeList2 = res.page.records
						for(var i = 0; i < this.CustomizeList2.length; i++){
							this.CustomizeList2[i].createDate = this.format2(this.CustomizeList2[i].createDate)
						}
						this.total = res.page.total
						this.loading = false
					})
					.catch((err) => { });
			}else{
				this.$fetchGet(url, parma)
					.then((res) => {
						console.log(res);
						this.loading = false
						this.CustomizeList = res.page.records
						this.NoticeList = res.page.records;
						this.CircularsList = res.page.records;
						this.ATelList = res.page.records;
						for(var i = 0; i < this.NoticeList.length; i++){
							this.NoticeList[i].noticeDate = this.format2(this.NoticeList[i].noticeDate)
						}
						for(var i = 0; i < this.CircularsList.length; i++){
							this.CircularsList[i].circularTime = format(this.CircularsList[i].circularTime,'yyyy-MM-dd hh:mm:ss')
						}
						for(var i = 0; i < this.ATelList.length; i++){
							if(this.ATelList[i].atelTime){
								this.ATelList[i].atelTime = format(this.ATelList[i].atelTime,'yyyy-MM-dd hh:mm:ss')
							}
						}
						for(var i = 0; i < this.CustomizeList.length; i++){
							this.CustomizeList[i].createDate = format(this.CustomizeList[i].createDate,'yyyy-MM-dd hh:mm:ss')
						}
						this.total = res.page.total
					})
					.catch((err) => { });
			}
		},
		format2(date){
		   var date = new Date(date);
		   var Y = date.getFullYear() + '-';
		   var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
		   var D = date.getDate() + ' ';
		   var h = date.getHours() + ':';
		   var m = date.getMinutes() + ':';
		   var s = date.getSeconds(); 
		   var a = Y+M+D+h+m+s; 
		    return a; 
		},
		handchange(e){
			this.pageNo = e
			console.log(e)
			this.pageNo = e
			this.getData(this.typeName)
		},
		format(date,fmt){
		    var o = { 
		        "M+" : date.getMonth()+1,                 //月份 
		        "d+" : date.getDate(),                    //日 
		        "h+" : date.getHours(),                   //小时 
		        "m+" : date.getMinutes(),                 //分 
		        "s+" : date.getSeconds(),                 //秒 
		        "q+" : Math.floor((date.getMonth()+3)/3), //季度 
		        "S"  : date.getMilliseconds()             //毫秒 
		    }; 
		    //(y+)匹配多个y，比如yyyy
		    if(/(y+)/.test(fmt)) {
		         // RegExp.$1是RegExp的一个属性,指的是与正则表达式匹配的第一个 子匹配(以括号为标志)字符串
		            fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length)); 
		    }
		     for(var k in o) {
		        if(new RegExp("("+ k +")").test(fmt)){
		             fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
		         }
		     }
		    return fmt; 
		},
		sizeChange(e){
			this.pageSize = e
			this.getData(this.typeName)
		},
		headerFn(h, data) {
			return h("span", [
				h(
					"el-tooltip",
					{
						attrs: {
							class: "item",
							dffect: "drak",
							content: data.column.label,
							placement: "top",
						},
					},
					[h("span", data.column.label)]
				),
			]);
		},
		onSubmit() {
			this.loading = true
			this.getData(this.typeName)
			// this.value1
			// let param = {
			// 	beginTriggerTime:this.value1,
			// 	endTriggerTime:this.value2,
			// 	objectName:this.input
			// }
		},
		changeCheck(val) {
			if (this.checkList.length > 1) {
				this.checkList.shift();
			}
			this.getData(this.checkList[0]);
		},
		changeCheck2(val) {
			//   console.log(val);
			  // if (this.checkList2.length > 1) {
			  //   this.checkList2.shift();
			  // }
        this.getData(this.checkList[0]);
		},
	},
};
</script>
<style scoped lang="less">
	/deep/.content-input .el-input>.el-input__inner {
		border-radius: 20px !important;
		height: 33px !important;
		text-align: center!important;
		line-height: 33px !important;
	}
	
	/deep/ input::input-placeholder {
		text-align: center;
	}
	
	/deep/ input::-ms-input-placeholder {
		text-align: center;
	}
	
	/deep/ input::-webkit-input-placeholder {
		text-align: center;
	}
.main {
	position: relative;
	margin-top: -70px;
	z-index: 99;
	width: 100%;
	height: auto;
	background: #fff;
	border-radius: 0 120px 0 0;
}

.cutMain {
	margin-top: 26px;
	display: flex;
	justify-content: space-between;
	margin-bottom: 40px;
}

.conner {
	width: 1050px;
	margin: 0 auto;
	text-align: left;
}

.leftCheck {
	width: 180px;
}

.checkList {
	border: 1px solid #e6ebf3;
	border-top: 0;
	padding: 5px 20px;
}

.checkList label {
	margin-top: 15px;
}

.CuntPage {
	width: 100%;
	height: 44px;
	margin-top: 17px;
	margin-bottom: 52px;
}

.pagination {
	text-align: center;
}

.leftCheck .title {
	width: 180px;
	height: 42px;
	background: linear-gradient(90deg, #144072, #1680b7);
	border-radius: 5px;
	font-size: 15px;
	font-family: Alibaba Sans;
	font-weight: bold;
	color: #ffffff;
	text-align: center;
	line-height: 42px;
}

.tabList {
	display: flex;
	height: 41px;
}

.eventstable {
	width: 810px;
	flex: 1;
	margin-left: 60px;
}

.tab {
	flex: 1;
	border: 1px solid #e5e5e5;
	border-radius: 6px;
	text-align: center;
	line-height: 38px;
	font-size: 16px;
	font-family: Arial-Bold, Arial;
	font-weight: bold;
	cursor: pointer;
}

.line {
	width: 1050px;
	height: 1px;
	background: #e6ebf3;
}

.sec {
	margin-top: 15px;
}

.tab.isActive {
	background: linear-gradient(90deg, #144072, #1680b7);
	border-radius: 6px;
	opacity: 1;
	border: 1px solid #ffffff;
	color: #fff;
}

.content-input-left-footer {
	height: 106px;
	border-bottom: 1px solid #e6ebf3;
	display: flex;
	align-items: center;
}

.content-input-left-footer-bottom p {
	margin: 0;
	line-height: 40px;
}

.content-input-left-footer-top {
	display: flex;
}

.content-input-left-footer-top>h1 {
	font-size: 14px;
	font-family: Alibaba Sans;
	font-weight: bold;
	color: #333333;
}

.content-input-left-footer-top>.el-input {
	margin-left: 5px;
	width: 193px !important;
	height: 33px;
}

.content-input-left-footer-top>.to {
	margin-left: 5px;
	line-height: 35px;
	font-size: 14px;
	font-family: Alibaba Sans;
	font-weight: 400;
	color: #666666;
}

.content-input-left-footer-bottom {
	display: flex;
	margin-left: 41px;
}

.content-input-left-footer-bottom>p {
	font-size: 14px;
	font-family: Alibaba Sans;
	font-weight: bold;
	color: #333333;
}

.content-input-left-footer-bottom>.el-input {
	width: 225px;
	height: 33px;
	margin-left: 8px;
	margin-top: 4px;
	text-align: center!important;
}

.subBtn {
	display: flex;
	align-items: center;
	margin-left: 10px;
}


/deep/ input::input-placeholder {
	text-align: center;
}

/deep/ input::-ms-input-placeholder {
	text-align: center;
}

/deep/ input::-webkit-input-placeholder {
	text-align: center;
}

/deep/ .el-table__row>.el-table__cell>.cell {
	font-size: 13px;
}
</style>


<style lang="less" scoped>
.content-input-right-footer {
		background: #168ec7;
		display: inline-block;
		    line-height: 1;
		    white-space: nowrap;
		    cursor: pointer;
		    border: 1px solid #DCDFE6;
		    color: #ffffff;
		    -webkit-appearance: none;
		    text-align: center;
		    box-sizing: border-box;
		    outline: 0;
		    margin: 0;
		    transition: .1s;
		    font-weight: 500;
		    padding: 12px 20px;
		    font-size: 14px;
			border-radius: 20px;
			margin-left: 20px!important;
			margin-bottom: 0!important;
	}
	.content-input-right-footer:hover {
		background: #168ec7;
		opacity: 0.8;
	}
	.content-input-right-top{
		    display: inline-block;
		    line-height: 1;
		    white-space: nowrap;
		    cursor: pointer;
		    background: #FFF;
		    border: 1px solid #DCDFE6;
		    color: #606266;
		    -webkit-appearance: none;
		    text-align: center;
		    box-sizing: border-box;
		    outline: 0;
		    margin: 0;
		    transition: .1s;
		    font-weight: 500;
		    padding: 12px 20px;
		    font-size: 14px;
			border-radius: 20px;
	}
	.content-input-right-top:hover {
		opacity: 0.8;
	}
.search .el-input__inner {
	width: 193px;
	height: 33px;
	border-radius: 33px;
	text-align: center;
}

.search .content-input-left-footer-top>.el-input {
	line-height: 40px !important;
}

/* .el-icon-warning-outline {
  font-size: 18px;
  font-weight: bold;
  color: #1191cb;
} */
.search .el-input__prefix>.el-input__icon {
	color: #168ec7 !important;
	font-weight: bold;
}

.checkList .el-checkbox__input.is-checked+.el-checkbox__label {
	color: #008dc9 !important;
}

.eventstable .el-table thead .el-table__cell {
	padding: 0 !important;
}

.el-table__header-wrapper {
	border-top: 3px solid #168ec7;
	/* height: 42px; */
	background: #f0f3f8 !important;
}

.eventstable .el-table thead tr {
	height: 42px;
}

.eventstable .el-table tr:nth-child(even) {
	background: #f7f9fb;
}

.cell {
	font-size: 14px;
	text-align: center;
}

.is-leaf {
	font-size: 14px;
	color: #168ec7;
	font-family: Alibaba Sans;
	font-weight: 800;
}
.checkListitem{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
}
.p-tw{
  width: 200px;
}
</style>
